export const API_ROOT = "https://api.jurajkusnier.com/" //"http://localhost:8080/" //"https://api.jurajkusnier.com/"